import request from '@/utils/request'
import { da } from 'date-fns/locale'
const perfix = ''
export function login(data) {
  return request({
    url: '/auth-api/v1/auth/unifyLogin',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: `${perfix}/admin/auth/getUserInfo`,
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}
// 获取用户对应项目所有权限
export function getAuthList(params) {
  // `${perfix}/admin/auth/getResource`
  return request({
    url: `/auth-api/v1/auth/getCurrentUserResourceModelList`,
    method: 'get',
    params
  })
}

// 获取用户对应项目所有权限（后台版）

export function getAuthListbackstage(params) {
  return request({
    url: `/auth-api/v1/auth/getCurrentUserNewResourceModelList`,
    method: 'get',
    params
  })
}

// 记录切换酒店
export function reportHotel(params) {
  return request({
    url: `/admin/auth/changeCurrentHotelCode`,
    method: 'get',
    params
  })
}
// 获取酒店营业日
export function getWokingDay(params) {
  return request({
    url: `/night/obtainBusinessDay`,
    method: 'get',
    params
  })
}
// 获取酒店营业日变更日志
export function getWokingDayLogList(params) {
  return request({
    url: `/night/queryByHotelCode`,
    method: 'get',
    params
  })
}
// 根据日期获取酒店营业日变更日志
export function getWokingDayLogListByDate(params) {
  return request({
    url: `/night/queryByNightDate`,
    method: 'get',
    params
  })
}
// 模糊查询酒店
export function getHotelListByCode(params) {
  return request({
    url: `/admin/auth/searchHotelCode`,
    method: 'get',
    params,
    trail: true
  })
}
// 查询乐惠支付设置
export function getLehuiPayWay(params) {
  return request({
    url: `/hardware/pay/config`,
    method: 'get',
    params
  })
}

// 前往指定APP项目
export function toApp(data) {
  return request({
    url: '/auth-api/v1/auth/toApp',
    method: 'post',
    data
  })
}

// 图形验证码验证
export function getImgCheck(data) {
  return request({
    url: '/auth-api/v1/users/checkVerificationCode',
    method: 'post',
    data
  })
}

// 获取手机验证码
export function getPhoneCheck(data) {
  return request({
    url: '/auth-api/v1/users/sendMsgByPhone',
    method: 'post',
    data
  })
}
// 重新设置密码
export function againNewPassword(data) {
  return request({
    url: '/auth-api/v1/users/updateByPhoneVerificationCode',
    method: 'post',
    data
  })
}

// 手机短信验证码验证
export function getMessageCheck(data) {
  return request({
    url: '/auth-api/v1/users/checkVerificationCodePhone',
    method: 'post',
    data
  })
}

// 获取登录二维码
export function getQrcode() {
  return request({
    url: '/auth-api/v1/auth/qrcode',
    method: 'get'
  })
}
// 查询二维码扫码情况
export function qrcodeCheck(data) {
  return request({
    url: '/auth-api/v1/auth/qrcodeCheck',
    method: 'post',
    data
  })
}
// 绑定微信
export function bindWx(data) {
  return request({
    url: '/auth-api/v1/auth/bindWx',
    method: 'post',
    data
  })
}

//获取酒店是否开通直连渠道
export function onlineChannelIsOpen(params) {
  return request({
    url: `/room/channel/onlineChannelIsOpen`,
    method: 'get',
    params
  })
}


// 注册
export function saasUserRegister(data) {
  return request({
    url: "/auth-api/v1/auth/saasUserRegister",
    method: "post",
    data,
  });
}

// 重置密码
export function retrievePassword(data) {
  return request({
    url: "/auth-api/v1/auth/retrievePassword",
    method: "post",
    data,
  });
}

// 图形验证码验证
export function puzzleCaptchaSendVerificationCode(data) {
  return request({
    url: "/auth-api/v1/auth/puzzleCaptchaSendVerificationCode",
    method: "post",
    data,
  });
}


export function generatePuzzleCaptcha(params) {
  return request({
    url: "/auth-api/v1/auth/generatePuzzleCaptcha",
    method: 'get',
    params
  });
}

export function verifyPuzzleCaptcha(data) {
  return request({
    url: "/auth-api/v1/auth/verifyPuzzleCaptcha",
    method: "post",
    data,
  });
}

//判断当前酒店是否需要必须输入证件证号
export function getRequiredIdResult(params) {
  return request({
    url: `/system/settings/base/info/checkIsRequiredIdNumberForCheckIn`,
    method: 'get',
    params,
  });
}
